import { ConstructGet } from '../../types/ConstructGet';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { PLUGIN_BASE_PATH } from '../constants/pluginBasePath';

export const getGuarantorRoles = (
  constructGet: ConstructGet,
  uuid: string,
): Promise<NonPaginatedResponse<any[]> | undefined> =>
  constructGet<NonPaginatedResponse<any[]>>(
    `${PLUGIN_BASE_PATH}/add-guarantor/list-roles/${uuid}`,
    {},
  );
